<template lang="pug">
    .mute-customer
        .info_basic_title
            .title-left
            span {{ $t(`${BASE_TRANSLATION_PATH}.title`) }}
            aiq-tooltip(effect="dark"
                    :show-after="1000"
                    :content="$t(`${BASE_TRANSLATION_PATH}.tooltip`)")
                fa-icon.question-mark(:icon="['fas', 'circle-question']")
        .toggle-switch
            aiq-switch(:model-value="isMuted" @change="toggleMute"
            style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA")
</template>

<script>
export default {
  name: 'MuteCustomer',
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  emits: ['mute-toggled'],
  data() {
    return {
      BASE_TRANSLATION_PATH: 'conversation_tab.side_panel.customer_info_accordion.section.mute_info',
      isMuted: false,
    };
  },
  mounted() {
    this.isMuted = this.customer.muted;
  },
  watch: {
    customer: {
      handler(newCustomer) {
        this.isMuted = newCustomer.muted;
      },
      deep: true,
    },
  },
  methods: {
    async toggleMute() {
      try {
        await this.$store.dispatch('conversations/muteCustomer', this.customer);
        this.isMuted = !this.isMuted;
        const muteMsg = this.isMuted ? this.$t(`${this.BASE_TRANSLATION_PATH}.is_muted`, { lynq_id: this.customer.id }) : this.$t(`${this.BASE_TRANSLATION_PATH}.is_unmuted`, { lynq_id: this.customer.id });
        this.$emit('mute-toggled', {
          isMuted: this.isMuted,
          message: muteMsg,
        });
        this.$aiq.notify.success(this.isMuted ? this.$t(`${this.BASE_TRANSLATION_PATH}.muted`) : this.$t(`${this.BASE_TRANSLATION_PATH}.unmuted`));
      } catch (error) {
        this.$aiq.notify.error(`Failed to update mute status: ${error.message}`);
      }

    },
  },
};
</script>

<style scoped lang="scss">

.question-mark {
    padding-left: 5px;
}
.info_basic_title {
    font-size: 14px;
    font-weight: 600;
    font-family: 'Roboto';
}
.mute-customer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 10px;
}

</style>